<template>
  <div id="get-set-up">
    <div v-if="!activeComponent">
      <!-- <notification-message
        iconClass="el-icon-check"
        :message="$t('common.account_confirmed')"
      /> -->
      <el-alert :title="$t('onboarding.you_do_not_belong_to_any_org')" type="warning" description="Ask for your organization admin to get organization access permission." close-text="Dismiss" show-icon> </el-alert>
      <div class="content base-component">
        <onboarding-options-picker
          :options="pickerOptions"
          :title="code ? $t('start_learning.start_practice') : $t('start_learning.start_learning')"
          :subtitle="code ? $t('start_learning.you_can_download') : $t('start_learning.or_send_the_email_by_link_sms')"
          :buttonText="$t('school.setup_school.continue')"
          @continueEvent="moveToNextStep"
          :showDownloadAppLinks="true"
        />
      </div>
      <create-edit-school :dialogVisible="modals.showCreateEditSchool" v-on:closed="handleClose" />
      <create-edit-company :dialogVisible="modals.showCreateEditCompany" v-on:closed="handleClose" />
    </div>
    <component v-if="activeComponent" :is="activeComponent" :fromTeacher="fromTeacher" />
  </div>
</template>

<script>
import NotificationMessage from '@/components/common/NotificationMessage'
import CreateEditSchool from '@/components/modals/school/CreateEditSchool'
import CreateEditCompany from '@/components/modals/company/CreateEditCompany'
import SetupSchool from '@/views/SetupSchool'
// Uncomment when invitation code is available
// import SetupTeacher from '@/views/SetupTeacher'
// import SetupStudent from '@/views/SetupStudent'
import StartLearning from '@/views/StartLearning'
import SetupCompany from '@/views/SetupCompany'
import OnboardingOptionsPicker from '@/components/common/OnboardingOptionsPicker'

export default {
  components: {
    CreateEditSchool,
    SetupSchool,
    CreateEditCompany,
    SetupCompany,
    // SetupTeacher,
    // SetupStudent,
    StartLearning,
    NotificationMessage,
    OnboardingOptionsPicker
  },
  data() {
    return {
      code: {
        type: Object,
        default: () => {}
      },
      modals: {
        showCreateEditSchool: false,
        showCreateEditCompany: false
      },
      fromTeacher: false,
      activeComponent: null,
      pickerOptions: [
        // Hide creation of school and company for the MVP
        // {
        //   input: 'school',
        //   image: 'school.svg',
        //   name: this.$t('onboarding.school_admin')
        // },
        // {
        //   input: 'company',
        //   image: 'company.svg',
        //   name: this.$t('onboarding.company_admin')
        // },
        // Hide Teacher onboarding flow for now
        // {
        //   input: 'teacher',
        //   image: 'teacher.svg',
        //   name: this.$t('onboarding.teacher')
        // },
        // {
        //   input: 'student',
        //   image: 'student.svg',
        //   name: this.$t('onboarding.student')
        // }
      ]
    }
  },
  mounted() {
    // TODO: this need to be changed
    // this.$store.dispatch('loadAdminUserData')
  },
  methods: {
    handleClose(type) {
      if (type === 'school') {
        this.activeComponent = 'setup-school'
        // this.$store.dispatch('finishOnboarding' , { role: 'school-admin' })
        // this.$router.push({ path: '/' })
      } else if (type === 'company') {
        this.activeComponent = 'setup-company'
      }

      this.modals.showCreateEditSchool = false
      this.modals.showCreateEditCompany = false
    },
    moveToNextStep(pickedOption) {
      switch (pickedOption) {
        case 'school':
          this.modals.showCreateEditSchool = true
          break
        case 'company':
          this.modals.showCreateEditCompany = true
          break
        case 'teacher':
          this.fromTeacher = true
          this.activeComponent = 'setup-school'
          break
        case 'student':
          this.activeComponent = 'start-learning'
          break
        default:
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../scss/_colors.scss';
p {
  margin: 0;
  font-size: 18px;
  color: $dark-blue-2;
  line-height: 1;
  text-align: initial;
}

.content {
  display: table;
  margin: 0 auto;
}

.welcome {
  margin-bottom: 75px;
  margin-top: 44px;
  h1 {
    color: $darker-blue;
    border: none;
  }
}

.content {
  display: table;
  margin: 0 auto;
  margin-top: 48px;
}

.base-component::v-deep .picker .options {
  grid-template-columns: 437px 437px;
}

#get-set-up {
  width: 100%;
}
</style>
